"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAllegroHeader = exports.parseAllegroFile = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./blockType"), exports);
tslib_1.__exportStar(require("./formatVersion"), exports);
tslib_1.__exportStar(require("./blockStructs"), exports);
tslib_1.__exportStar(require("./stream"), exports);
var parser_1 = require("./parser");
Object.defineProperty(exports, "parseAllegroFile", { enumerable: true, get: function () { return parser_1.parseAllegroFile; } });
Object.defineProperty(exports, "parseAllegroHeader", { enumerable: true, get: function () { return parser_1.parseAllegroHeader; } });
//# sourceMappingURL=index.js.map